// extracted by mini-css-extract-plugin
module.exports = {"summary":"FilterSummary_summary__iIicw"};